// Action Constants
export const APP_NAVIGATED = 'APP_NAVIGATED';

// Action Interfaces
export interface IAppNavigatedAction {
  type: typeof APP_NAVIGATED;
  payload: {
    path: string;
  };
}

// Union type for all app actions
export type AppActionTypes = IAppNavigatedAction;
